// Small anchored info popover — opens on click only, stays open until
// explicitly closed (close button or a click outside it). Modeled on the
// same open/close/outside-click/Escape pattern as the localization-form
// component (component-localization-form.js), rather than the full-screen
// theme-modal system, since this is a small anchored card, not an overlay.
class InfoPopover extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('[data-info-popover-trigger]');
    this.panel = this.querySelector('[data-info-popover-panel]');
    this.closeButton = this.querySelector('[data-info-popover-close]');

    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.handleKeyup = this.handleKeyup.bind(this);
  }

  connectedCallback() {
    if (!this.trigger || !this.panel) return;

    this.trigger.addEventListener('click', (event) => {
      event.preventDefault();
      this.isOpen() ? this.close() : this.open();
    });

    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.close());
    }

    document.addEventListener('mousedown', this.handleDocumentClick);
    this.addEventListener('keyup', this.handleKeyup);
  }

  disconnectedCallback() {
    document.removeEventListener('mousedown', this.handleDocumentClick);
  }

  isOpen() {
    return !this.panel.hidden;
  }

  open() {
    this.panel.hidden = false;
    this.trigger.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.panel.hidden = true;
    this.trigger.setAttribute('aria-expanded', 'false');
  }

  handleDocumentClick(event) {
    if (this.isOpen() && !this.contains(event.target)) {
      this.close();
    }
  }

  handleKeyup(event) {
    if (event.code && event.code.toUpperCase() === 'ESCAPE') {
      this.close();
      this.trigger.focus();
    }
  }
}

customElements.define('info-popover', InfoPopover);
